module.exports = __webpack_public_path__ + "static/media/zind_rugarama11.4da15b61.jpg";